import { CommonModule } from '@angular/common';
import { Component, OnInit, TemplateRef, ViewChild, Inject } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FORM_TEXTS } from './placeholder';
import { Router } from '@angular/router';
import { InputModule } from 'src/app/common/input/input.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { IntlInputModule } from 'src/app/common/intl-input/intl-input.module';
import { ButtonModule } from 'src/app/common/button/button.module';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatRadioModule } from '@angular/material/radio';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatOptionModule } from '@angular/material/core';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { IOrder } from 'src/app/common/payment/models/order.model';
import { AuthService, EventsService, FundraiserService, UtilService, VariablesService } from 'src/app/shared/services';

@Component({
  selector: 'app-acknowledge-form',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    InputModule,
    SharedModule,
    IntlInputModule,
    ButtonModule,
    MatButtonModule,
    MatIconModule,
    MatRadioModule,
    MatFormFieldModule,
    MatSelectModule,
    MatOptionModule,
    MatCheckboxModule
  ],
  templateUrl: './acknowledge-form.component.html',
  styleUrls: ['./acknowledge-form.component.scss']
})
export class AcknowledgeFormComponent implements OnInit {

  ackForm: FormGroup;
  mode: FormControl;
  bankTxnId: FormControl;
  amount: FormControl;
  donorName: FormControl;
  donorNumber: FormControl;
  donorEmail: FormControl;
  isAnonymous: FormControl;
  info = FORM_TEXTS;
  order: IOrder;
  transactionPlaceholder = {
    bank: 'Stories.bankTransfer.bankTransferId',
    upi: 'Stories.bankTransfer.upiRefOrTxnId',
    paytm: 'Stories.bankTransfer.walletOrderId'
  };
  extn;
  isMobile: any;
  isLoading;
  @ViewChild('ackTemplate') public ackTemplate: TemplateRef<any>;
  constructor(
    public dialog: MatDialog,
    private util: UtilService,
    private fundraiserService: FundraiserService,
    private vars: VariablesService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private authService: AuthService,
    private events: EventsService,
    public router: Router
  ) { }

  ngOnInit() {
    this.isMobile = this.util.isMobile();
    this.ackForm = new FormGroup({
      mode: this.mode = new FormControl('', [Validators.required]),
      bankTxnId: this.bankTxnId = new FormControl('', [Validators.required]),
      amount: this.amount = new FormControl('', [Validators.required]),
      donorName: this.donorName = new FormControl('', [Validators.required]),
      donorNumber: this.donorNumber = new FormControl('', [Validators.required]),
      donorEmail: this.donorEmail = new FormControl('', [Validators.required]),
      isAnonymous: this.isAnonymous = new FormControl(false, [])
    });
    this.mode.setValue(this.data.mode);
    this.changePlaceholder(this.data.mode);
    if (this.data.amount) {
      this.amount.setValue(this.data.amount);
      this.bankTxnId.setValue(this.data.ref_no);
      this.bankTxnId.disable();
      this.amount.disable();
      this.mode.disable();
    }
    this.vars.userData.subscribe({
      next: (res) => {
        if (res) {
          this.ackForm.patchValue({
            donorName: res ? res.full_name : '',
            donorEmail: res ? res.email : '',
            donorNumber: res.phone_1 === '1111111111' ? '' : res.phone_1
          });
        }
      }
    });
    this.util.number.subscribe({
      next: (res) => {
        if (res && res.extn) {
          this.extn = res.extn;
        }
      }
    });
  }

  changePlaceholder(mode) {
    return this.info.bankTxnId.placeholder = this.transactionPlaceholder[mode];
  }
  /**Submit the ack form */
  submit() {
    if (this.ackForm.valid) {
      const payload = {
        'campaign_id': this.vars.fundraiser.id,
        'txn_id': this.bankTxnId.value,
        'donor_name': this.donorName.value,
        'donor_phone': this.donorNumber.value,
        'donated_amount': this.amount.value,
        'is_anonymous': this.isAnonymous.value,
        'donor_email': this.donorEmail.value,
        'pg': this.mode.value,
        'donor_extension': this.extn
      };
      this.submitAcknowledgeForm(payload);
    } else {
      this.util.checkValidForm(this.ackForm);
    }
  }
  /**Send update for acknowlegde form */
  submitAcknowledgeForm(payload) {
    this.isLoading = true;
    this.fundraiserService.submitAcknowledgeForm(payload).subscribe((res: any) => {
      this.isLoading = false;
      this.order = res.data.orderDetails;
      this.util.openSnackBar('Acknowledgement sent successfully', 'success');
      if (res.data.token) {
        this.authService.userLogin(res.data).then(() => this.eventTracking());
      } else {
        this.eventTracking();
      }
      this.showThankYouBanner();
      this.util.scrollToTop();
      this.dialog.closeAll();
    }, () => {
      this.isLoading = false;
    });
  }

  eventTracking() {
    this.events.sendSystemEvent({
      eventName: 'claim_your_donation',
      event_type: 'campaign',
      page_name: this.vars.pageName,
      event_type_id: this.vars.fundraiser.id,
      info_1: 'submitted'
    }).subscribe(_ => _);
  }

  showThankYouBanner() {
    this.router.navigate([], {
      queryParams: { oi: this.order.order_id },
      queryParamsHandling: 'merge'
    });
    this.util.storage.checkFromSession('showBanner', true);
    this.vars.showThankYoubanner.next(this.order.order_id);
  }
}
